import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Box } from '@material-ui/core';
import { SFormikTextfield } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Field, FieldProps } from 'formik';
import { UserRole } from 'pages/admin/pages/users/enum';
import { Photo } from 'pages/auto-rfq/pages/details/components/quote-details-modal/components';

const useStyles = makeStyles(({ spacing }) => ({
  disabledInput: {
    '& div input': {
      color: TextColor.Black
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3)
  },
  paddedBox: {
    paddingBottom: spacing(3)
  },
  titleText: {
    fontSize: '1rem',
    fontWeight: 500
  }
}));

interface UserInformationFormInterface {
  disabled: boolean;
  label: string;
  userRole?: number;
  onImageUpload?: (file: File | null) => void;
}

export const UserInformationForm = ({
  disabled,
  label,
  userRole,
  onImageUpload
}: UserInformationFormInterface) => {
  const classes = useStyles();

  const inputWithLabelList = [
    {
      name: 'FirstName',
      labelTitle: 'First Name',
      placeholder: 'Enter first name',
      required: true
    },
    {
      name: 'LastName',
      labelTitle: 'Last Name',
      placeholder: 'Enter last name',
      required: true
    },
    {
      name: 'Email',
      labelTitle: 'Email',
      placeholder: '',
      disabled: true
    },
    {
      name: 'ContactNumber',
      labelTitle: 'Phone Number',
      placeholder: 'Enter phone number',
      required: window.location.origin.includes('middleby')
    },
    {
      name: 'CompanyRole',
      labelTitle: 'Job Title',
      placeholder: 'Enter job title',
      disabled: userRole === UserRole.User
    }
  ];

  return (
    <>
      <Grid item xs={12}>
        <Box className={classes.paddedBox}>
          <Typography className={classes.titleText} variant="h6">
            {label}
          </Typography>
        </Box>
      </Grid>
      <Grid container className={classes.container}>
        <Grid item>
          <Field name="Avatar">
            {({ field, form }: FieldProps) => (
              <Photo
                size="large"
                name="Avatar"
                handleChange={(name, value, file) => {
                  form.setFieldValue(name, value);
                  onImageUpload?.(file || null);
                }}
                photo={field.value}
                alt={form.values.FirstName || ''}
              />
            )}
          </Field>
        </Grid>
        {inputWithLabelList.map(val => (
          <Grid item key={val.name}>
            <SFormikTextfield
              name={val.name}
              label={val.labelTitle}
              placeholder={val.placeholder}
              required={val.required}
              disabled={disabled || val.disabled}
              inputClass={classes.disabledInput}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
